import classnames from 'classnames';
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { Row } from 'reactstrap';
import { InlineTooltip } from '../tooltips';
import JsonEditor from '../JsonEditor'
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import './styles.css';
window['jsonlint'] = require('../lint/jsonlint');

const Label = ({
  error,
  className,
  children,
  ...props
}) => {
  return (
    <label className="label" {...props}>
      {children}
    </label>
  );
};

export class TextInput extends Component {
  constructor() {
    super();
    this.state = {
      value: []
    };
  }

  render() {
    const {
      type,
      id,
      label,
      textTooltip,
      error,
      value,
      onChange,
      required,
      className, disabled } = this.props;
    const classes = classnames(
      {
        'animated shake error': !!error,
      },
      className
    );
    let inline = [];
    if (textTooltip !== undefined) {
      inline = <InlineTooltip id={id} text={textTooltip} />
    }
    return (
      <div style={{ marginBottom: 10 }}>
        <Row>
          <div className="col-md-12" style={{ paddingTop: 2 }}>
            <div className={classes}>
              <Label htmlFor={id} error={error}>
                {label}{required ? "* " : <span className='text-iotera-optional'>{' (Optional) '}</span>}
                {inline}
              </Label>
            </div>
          </div>
        </Row>
        <Row>
          <div className="col-md-12"  >
            <div className={classes}>
              <InputMask
                className="input-mask"
                id={id}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={this.props.placeholder}
                disabled={disabled}
              />
            </div>
          </div>
        </Row>
        <Row>
          <div className="col-md-12">
            <div className={classes}>
              <InputFeedback error={error} />
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

export class AreaInput extends Component {
  constructor() {
    super();
    this.state = {
      value: []
    };
  }

  render() {
    const {
      id,
      label,
      textTooltip,
      error,
      required,
      className } = this.props;
    const classes = classnames(
      {
        'animated shake error': !!error,
      },
      className
    );
    let inline = [];
    if (textTooltip !== undefined) {
      inline = <InlineTooltip id={id} text={textTooltip} />
    }
    return (
      <div style={{ marginBottom: 10 }}>
        <Row>
          <div className="col-md-12" style={{ paddingTop: 2 }}>
            <div className={classes}>
              <Label htmlFor={id} error={error}>
                {label}{required ? "* " : <span className='text-iotera-optional'>{' (Optional) '}</span>}
                {inline}
              </Label>
            </div>
          </div>
        </Row>
        <Row>
          <div className="col-md-12"  >
            <div className={classes} style={{ padding: 1, border: '1px solid #CED4DA' }}>
              <JsonEditor {...this.props} />
            </div>
          </div>
        </Row>
        <Row>
          <div className="col-md-12">
            <div className={classes}>
              <InputFeedback error={error} />
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

const InputFeedback = ({ error }) => error ? (<div className="input-feedback" style={{ fontStyle: 'italic' }}>{error}</div>) : null;